import { AdministrationScreen } from "@modules/administration/AdministrationScreen";
import { UserProfileScreen } from "@modules/administration/userProfile/UserProfileScreen";
import { DashboardScreen } from "@modules/monitor/DashboardScreen/DashboardScreen";
import { NightReportScreen } from "@modules/monitor/NightReportScreen/NightReportScreen";
import { SubjectScreen } from "@modules/monitor/SubjectScreen/SubjectScreen";
import { ZoneUserRole } from "constants/userContstants";
import { AppRoute } from "interfaces/router.interface";

const adminRoutes: AppRoute[] = [
  {
    path: "monitor/*",
    element: <DashboardScreen />,
    link: {
      href: "/monitor",
      name: "dashboard",
    },
    allowedRoles: [
      ZoneUserRole.DATA_READER,
      ZoneUserRole.DATA_READER_LIMITED,
      ZoneUserRole.SERVICE_MONITOR,
    ],
  },
  {
    path: "subject/:subjectId/*",
    element: <SubjectScreen />,
    allowedRoles: [
      ZoneUserRole.DATA_READER,
      ZoneUserRole.DATA_READER_LIMITED,
      ZoneUserRole.SERVICE_MONITOR,
    ],
  },
  {
    path: "night_report/*",
    element: <NightReportScreen />,
    link: {
      href: "/night_report",
      name: "Night Report",
    },
    allowedRoles: [ZoneUserRole.DATA_READER, ZoneUserRole.DATA_READER_LIMITED],
  },
  {
    path: "administration/*",
    element: <AdministrationScreen />,
    link: {
      href: "/administration",
      name: "Administration",
    },
    allowedRoles: [
      ZoneUserRole.ADMIN,
      ZoneUserRole.MANAGER,
      ZoneUserRole.MANAGER_LIMITED,
      ZoneUserRole.OWNER,
    ],
  },
  {
    path: "profile",
    element: <UserProfileScreen />,
    allowedRoles: [
      ZoneUserRole.ADMIN,
      ZoneUserRole.MANAGER,
      ZoneUserRole.MANAGER_LIMITED,
      ZoneUserRole.OWNER,
      ZoneUserRole.DATA_READER,
      ZoneUserRole.DATA_READER_LIMITED,
      ZoneUserRole.SERVICE_MONITOR,
    ],
  },
];

export default adminRoutes;
